import { noop } from "lodash";
import React from "react";
import { ScopeWrap } from "./styled";
import { Typography } from 'antd';
const { Title } = Typography;

function FilterLabel({ tagColor, text, disabled = false, onClick = noop  }) {

  return (
    <ScopeWrap
      tagColor={tagColor}
      disabled={disabled}
      onClick={disabled ? noop : onClick}
    >
      <Title level={3} style={{ fontWeight: 400 }}>{text}</Title>
    </ScopeWrap>
  );
}

export default FilterLabel
